import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { EmailDetails, EmailResponse } from '../models/email.model';
import { SimpleResponse } from '../models/genericResponse.model';
import { delayedRetryHttp } from './shared/delayedRetry';


@Injectable({
    providedIn: 'root'
})
export class EmailService {

    private baseUrl: string;
    private nabaseUrl: string;
    private api: string = "api/Email";
    private naapi: string = "api/NonAuthEmail";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string) {
        this.baseUrl = _baseUrl + this.api;
        this.nabaseUrl = _baseUrl + this.naapi;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Email Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }
    }

    async sndEmailAsync(encryptedUser: string, emailDetails: EmailDetails): Promise<SimpleResponse | void> {
        if (isNullOrUndefined(encryptedUser)) {
            encryptedUser = window.localStorage.getItem('token');
        }

        if (!isNullOrUndefined(encryptedUser)) {
            const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/SendEmailPost`, emailDetails, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this.handleErrors });
            return a;
        }
    }

    async sndNAEmailAsync(emailDetails: EmailDetails): Promise<SimpleResponse | void> {
        const a = await this.httpClient.post<SimpleResponse>(`${this.nabaseUrl}/SendEmailPost`, emailDetails, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this.handleErrors });
        return a;
    }
}
